import { useState } from 'react';

import { useTranslation } from 'providers/GILT.provider';

const CashupHeader = ({ byRangeModal: byRangeClassName, onDayRangeClick }) => {
  const [isRangeMode, setIsRangeMode] = useState(false);
  const { t } = useTranslation();

  const onDayRangeClickHandler = (event) => {
    event.preventDefault();
    onDayRangeClick();
    setIsRangeMode((prev) => !prev);
  };

  return (
    <div data-bem="CashupHeader" className={byRangeClassName}>
      <li data-bem="CashupHeader__day">
        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
        <a
          className={isRangeMode ? ' ' : ' active'}
          onClick={isRangeMode ? onDayRangeClickHandler : (event) => event.preventDefault()}
          role="menuitem"
          tabIndex={0}
        >
          {t('cashUp.header.byDay')}
        </a>
      </li>
      <li data-bem="CashupHeader__range">
        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
        <a
          className={isRangeMode ? ' active' : ' '}
          onClick={isRangeMode ? (event) => event.preventDefault() : onDayRangeClickHandler}
          role="menuitem"
          tabIndex={0}
        >
          {t('cashUp.header.dateRange')}
        </a>
      </li>
    </div>
  );
};

export default CashupHeader;
